import { getBackendUrl } from "@lib/util/backend-url"

/**
 * The customer-facing referral terms, read from the backend (which reads the
 * referral settings) so no "$25" is ever typed into a component. Cached for a
 * minute per server; falls back to the standing terms if the backend is down,
 * so a fetch hiccup can never blank out the referral copy.
 */
export type ReferralProgram = {
    referee_discount: number
    reward_amount: number
    min_order_value: number
    event_ends_at: string | null
    event_active: boolean
    insider_threshold: number
    insider_reward_amount: number
}

export const DEFAULT_REFERRAL_PROGRAM: ReferralProgram = {
    referee_discount: 25,
    reward_amount: 25,
    min_order_value: 100,
    event_ends_at: null,
    event_active: false,
    insider_threshold: 5,
    insider_reward_amount: 50,
}

export async function getReferralProgram(): Promise<ReferralProgram> {
    try {
        const res = await fetch(`${getBackendUrl()}/store/referral/program`, {
            headers: { "x-publishable-api-key": process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY || "" },
            next: { revalidate: 60 },
        })
        if (!res.ok) return DEFAULT_REFERRAL_PROGRAM
        const j = await res.json()
        return { ...DEFAULT_REFERRAL_PROGRAM, ...j }
    } catch {
        return DEFAULT_REFERRAL_PROGRAM
    }
}
